import { Typography } from "@mui/material";
import { ReactComponent as AddIcon } from "../../../assets/icons/add-icon.svg";

import { useDroppable } from "@dnd-kit/core";

import "./add-widget.scss";

interface AddWidgetInterface {
  id: string
  onAddWidgetClick: () => void;
}


const AddWidget = ({ onAddWidgetClick, id }: AddWidgetInterface) => {
   const { setNodeRef, isOver } = useDroppable({
    id: id,
  });

  return (
    <div className={`add-widget-container ${isOver ? "drop-active" : ""}`}
      ref={setNodeRef}>
      <div className="add-icon-parent " onClick={onAddWidgetClick}>
        {/* <img src={AddIcon} alt="Add widget" className="aad-icon" /> */}
        <AddIcon color="var(--primary-color)" />
      </div>
      <div>
        <Typography className="add-widget-text">Add Widget</Typography>
      </div>
    </div>
  );
};

export default AddWidget;
